import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  startDate: moment().subtract(1, 'years').format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
};

export const dateRangeSlice = createSlice({
  name: 'dateRange',
  initialState,
  reducers: {
    setDateRange: (state, action) => {
      if (action.payload?.startDate && action.payload?.endDate) {
        state.startDate = moment(action.payload.startDate).format("YYYY-MM-DD");
        state.endDate = moment(action.payload.endDate).format("YYYY-MM-DD");
      } else {
        console.error("Invalid date range payload:", action.payload);
      }
    },
  },
});

export const { setDateRange } = dateRangeSlice.actions;
export const selectDateRange = (state) => state.dateRange;
export default dateRangeSlice.reducer;
